const LEAD_DEM = '#78A8F5';
const LEAD_GOP = '#F65757';
const LEAD_OTH = '#B1E983';
const WIN_DEM = '#0B44AB';
const WIN_GOP = '#CC2129';
const WIN_OTH = '#90C169';
const GRAY = '#DDDDDD';
const TIE = '#FAC842';

export const getPhase = (status = '') => {
    const text = String(status);
    if (/已出结果|已结束|有结果|已完成/.test(text)) return 'final';
    if (/计票|进行中|统计中/.test(text)) return 'counting';
    return 'pending';
};

/**
 * 已出结果时，民主党、共和党、其他三个席位一起比。
 * 只有一方席位最多才获胜；最高席位有两方及以上相同为平局。
 * 众议院计票中按领先方上浅色。参议院、州长没有领先，只按票数判胜负。
 * 只有 1 个席位时，拿到该席的一方整条获胜。
 */
export const getOutcome = ({ total = 0, dem = 0, gop = 0, oth = 0, status = '' } = {}, { byCount = false } = {}) => {
    const phase = getPhase(status);
    const seats = Number(total) || 0;
    const demSeats = Number(dem) || 0;
    const gopSeats = Number(gop) || 0;
    const othSeats = Number(oth) || 0;
    const single = seats <= 1;
    const called = phase === 'final';
    const counting = phase !== 'final';
    const decided = called || byCount;
    let label = '计票中...';

    if (decided) {
        const top = Math.max(demSeats, gopSeats, othSeats);
        const leaders = [demSeats, gopSeats, othSeats].filter(count => count === top).length;

        if (top <= 0) label = called ? '其他' : '计票中...';
        else if (leaders > 1) label = '平局';
        else if (demSeats === top) label = '民主党获胜';
        else if (gopSeats === top) label = '共和党获胜';
        else label = '其他获胜';
    }

    const demFill = decided ? WIN_DEM : LEAD_DEM;
    const gopFill = decided ? WIN_GOP : LEAD_GOP;
    const othFill = decided ? WIN_OTH : LEAD_OTH;
    let demWidth = 0;
    let gopWidth = 0;
    let othWidth = 0;

    if (seats > 0) {
        if (single && label === '民主党获胜') demWidth = 100;
        else if (single && label === '共和党获胜') gopWidth = 100;
        else if (single && label === '其他获胜') othWidth = 100;
        else {
            demWidth = (demSeats / seats) * 100;
            gopWidth = (gopSeats / seats) * 100;
            othWidth = (othSeats / seats) * 100;
        }
    }

    let mapFill = GRAY;
    if (label === '民主党获胜') mapFill = WIN_DEM;
    else if (label === '共和党获胜') mapFill = WIN_GOP;
    else if (label === '其他获胜') mapFill = WIN_OTH;
    else if (label === '平局') mapFill = TIE;
    else if (!decided && demSeats > gopSeats && demSeats > othSeats && demSeats > 0) mapFill = LEAD_DEM;
    else if (!decided && gopSeats > demSeats && gopSeats > othSeats && gopSeats > 0) mapFill = LEAD_GOP;
    else if (!decided && othSeats > demSeats && othSeats > gopSeats && othSeats > 0) mapFill = LEAD_OTH;

    return {
        phase,
        label,
        single,
        showMeta: seats > 1,
        showCount: seats > 1,
        muted: counting,
        demWidth,
        gopWidth,
        othWidth,
        demFill,
        gopFill,
        othFill,
        gray: GRAY,
        mapFill,
    };
};
